import type { QueryClient } from '@tanstack/react-query';
import { notFound } from '@tanstack/react-router';
import { featuresQuery } from '@/features/feature-flags/use-feature';

/** Route guard (beforeLoad): the board ships behind the `board` feature flag until released. */
export async function requireBoardFeature(queryClient: QueryClient): Promise<void> {
  const { flags } = await queryClient.query(featuresQuery);
  if (!flags.board || !flags.tasks) throw notFound();
}
